import React from 'react';
import UserManager from '../user-manager/UserManager';

const App = () => {
  return <UserManager />;
};

export default App;
